import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import style from './style.module.css';
import Modal from 'react-modal';

@inject(store => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})

@observer
class TermsModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalStyle = {
            content : {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '20px',
                width: '60%',
                maxHeight: '600px'
                
            },
            overlay: {
                backgroundColor: "rgb(0, 0, 0, 0.65)",
                zIndex: 10
            }
        }
        if (window.matchMedia("(max-width: 850px)").matches) {
            this.modalStyle.content = {
                ...this.modalStyle.content,
                width: '92%;',
                maxWidth: '92%'
            };
        }
    }
 
    render() {
        const { modalIsOpen, closeModal, content, t } = this.props;
        const titles = {
            'rules': t('terms of use'),
            'privacy_policy': t('privacy policy'),
            //'cookies': t('cookies policy')
        }
        return (
            <Modal style={this.modalStyle} isOpen={modalIsOpen} onRequestClose={closeModal}>
                <div className={style.ModalContainer}>
                    <div className={style.ModalTitle}>
                        <span>{titles[content]}</span>
                    </div>
                    <div className={style.ModalContent}>
                        { this.props.myShopApiStore.shopData[content] }
                    </div>
                    <div className={style.ModalButton} onClick={closeModal}>
                        <span>{t('allow')}</span>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default withTranslation()(TermsModal);